// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"483d5ede","455":"e22bd84b","977":"5327d194"}[chunkId] + ".chunk.js";
};